import { render, staticRenderFns } from "./assignee_avatar.vue?vue&type=template&id=8e901b2c&"
import script from "./assignee_avatar.vue?vue&type=script&lang=js&"
export * from "./assignee_avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports